(function () {
  'use strict';

  var config = window.cursorTrailConfig;
  if (!config || !config.image) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var coarsePointer = window.matchMedia('(pointer: coarse)');

  if (reduceMotion.matches) return;
  if (!config.mobile && coarsePointer.matches) return;

  var size = Math.max(12, Math.min(48, Number(config.size) || 22));
  var density = Math.max(1, Math.min(8, Number(config.density) || 3));
  var lifetime = Math.max(300, Math.min(1200, Number(config.lifetime) || 700));
  var minDistance = Math.max(8, 28 - density * 2);
  var maxParticles = 28 + density * 4;

  var layer = document.createElement('div');
  layer.className = 'cursor-trail-layer';
  layer.setAttribute('aria-hidden', 'true');
  document.body.appendChild(layer);

  var lastX = null;
  var lastY = null;
  var active = 0;
  var pool = [];
  var rafId = 0;
  var pendingX = 0;
  var pendingY = 0;
  var hasPending = false;

  function createParticle() {
    var el = document.createElement('span');
    el.className = 'cursor-trail-particle';
    el.style.width = size + 'px';
    el.style.height = size + 'px';
    el.style.backgroundImage = 'url("' + String(config.image).replace(/"/g, '\\"') + '")';
    el.style.transition =
      'opacity ' + lifetime + 'ms ease-out, transform ' + lifetime + 'ms ease-out';
    layer.appendChild(el);
    return el;
  }

  function getParticle() {
    return pool.pop() || createParticle();
  }

  function releaseParticle(el) {
    el.style.opacity = '0';
    el.style.transform = 'translate3d(-9999px, -9999px, 0) scale(0.4)';
    pool.push(el);
    active = Math.max(0, active - 1);
  }

  function spawn(x, y) {
    if (active >= maxParticles) return;

    var el = getParticle();
    var driftX = (Math.random() - 0.5) * 16;
    var driftY = (Math.random() - 0.5) * 16 - 8;
    var startScale = 0.85 + Math.random() * 0.35;
    var endScale = 0.25 + Math.random() * 0.25;
    var rotate = (Math.random() - 0.5) * 40;

    active += 1;
    el.style.transition = 'none';
    el.style.opacity = '0.95';
    el.style.transform =
      'translate3d(' +
      (x - size / 2) +
      'px, ' +
      (y - size / 2) +
      'px, 0) scale(' +
      startScale +
      ') rotate(' +
      rotate +
      'deg)';

    // Force reflow so the fade transition runs from the start state.
    void el.offsetWidth;

    el.style.transition =
      'opacity ' + lifetime + 'ms ease-out, transform ' + lifetime + 'ms ease-out';
    el.style.opacity = '0';
    el.style.transform =
      'translate3d(' +
      (x - size / 2 + driftX) +
      'px, ' +
      (y - size / 2 + driftY) +
      'px, 0) scale(' +
      endScale +
      ') rotate(' +
      (rotate + (Math.random() - 0.5) * 30) +
      'deg)';

    window.setTimeout(function () {
      releaseParticle(el);
    }, lifetime + 40);
  }

  function flush() {
    rafId = 0;
    if (!hasPending) return;
    hasPending = false;

    var x = pendingX;
    var y = pendingY;

    if (lastX === null) {
      lastX = x;
      lastY = y;
      spawn(x, y);
      return;
    }

    var dx = x - lastX;
    var dy = y - lastY;
    var dist = Math.sqrt(dx * dx + dy * dy);
    if (dist < minDistance) return;

    var steps = Math.min(density, Math.floor(dist / minDistance));
    for (var i = 1; i <= steps; i++) {
      var t = i / steps;
      spawn(lastX + dx * t, lastY + dy * t);
    }

    lastX = x;
    lastY = y;
  }

  function onMove(event) {
    pendingX = event.clientX;
    pendingY = event.clientY;
    hasPending = true;
    if (!rafId) rafId = window.requestAnimationFrame(flush);
  }

  function onLeave() {
    lastX = null;
    lastY = null;
    hasPending = false;
  }

  document.addEventListener('mousemove', onMove, { passive: true });
  document.addEventListener('mouseleave', onLeave, { passive: true });

  reduceMotion.addEventListener('change', function (event) {
    if (event.matches) {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseleave', onLeave);
      layer.remove();
    }
  });
})();
